// K-Diagra, Data points
export function generateKDiagramDataSeries(data, name, pointFormat = null) {
  return {
    name: name,
    color: "var(--kdiagram-speed-range-color)",
    type: "scatter",
    zIndex: 50,
    data: data,
    marker: {
      enabled: true,
      symbol: "circle",
      radius: 2,
    },

    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
    tooltip: {
      pointFormat: pointFormat
    },
  };
}

/*
return {
        name: name,
        type: "scatter",
        data: data,
        marker: {
            radius: 3,
            fillColor: "var(--kdiagram-power-data-points-color)",
            symbol: 'circle',
            states: {
                hover: {
                    enabled: true,
                    lineColor: "var(--kdiagram-speed-range-color)"
                }
            }
        },
        fillOpacity: "0.7",
        animation: false,
        states: {
            hover: {
                enabled: false,
                marker: {
                    enabled: false
                }
            }
        },
        jitter: {
            x: 0.005
        },
        tooltip: {
            pointFormat: pointFormat
        }
    }
}

*/
